import React from 'react'

const SignatureStacked = ({contactInfo, disclaimer, sharedStyles}) => {
	const {headingStyle, pStyle, urlStyle} = sharedStyles;

	return(

		<div className="signatureBlock" id="stackedSignature">

			<p style={headingStyle}><strong>
			{contactInfo.name}
			</strong></p>

			{!!(contactInfo.pronouns) && 
			<div style={pStyle}>Pronouns: {contactInfo.pronouns}</div> }

			{!!(contactInfo.title) && 
			<div style={pStyle}>{contactInfo.title}</div> }			
			
			{!!(contactInfo.department) &&
			<div style={pStyle}>{contactInfo.department}</div>}

			{!!(contactInfo.image ==="Yes") && 
			<img src="https://www.unco.edu/_resources/images/email-signatures/unc-signature1.jpg" alt="University of Northern Colorado" />
			}

			<div>
				<br/>
				<div style={headingStyle}>University of Northern Colorado</div>
			
				{!!(contactInfo.building) &&
				<div style={pStyle}>{contactInfo.building}</div>}
				
				{!!(contactInfo.address) &&
				<div style={pStyle}>{contactInfo.address}</div>}

				{!!(contactInfo.campusbox) &&
				<div style={pStyle}>Campus Box {contactInfo.campusbox}</div>}

				{!!(contactInfo.city) &&
				<div style={pStyle}>{contactInfo.city}</div>}
			</div>
			<br/>
			{!!(contactInfo.phoneoffice) &&
			<div style={pStyle}>O: {contactInfo.phoneoffice}</div>}

			{!!(contactInfo.phonecell) &&
			<div style={pStyle}>C: {contactInfo.phonecell}</div>}

			{!!(contactInfo.phonefax) &&
			<div style={pStyle}>F: {contactInfo.phonefax}</div>}

			<div><a href="https://www.unco.edu" style={urlStyle}>unco.edu</a></div>
			
			{!!(disclaimer) &&
				<table border="0" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td height="24" style={sharedStyles.height24}></td>
						</tr>
						<tr>
							<td colSpan="2">
								<p className="disclaimer" style={sharedStyles.disclaimer}>
									{disclaimer}
								</p>
							</td>
						</tr>
						<tr>
							<td height="24" style={sharedStyles.height24}></td>
						</tr>
					</tbody>
				</table>
			}
		</div>

	)

}

export default SignatureStacked;